
import Vue from 'vue'
export default new Vue({  
    data(){
      return {
      Province: {
        Trang: [7.9608531,98.272695],
        Phuket: [7.8774353,98.385418],
        Surathani : [7.8774353,98.385418]
      }
      }
    }
  });